import { clasolSuiteApi } from '../axiosConfig'
import { buildListParams, withSuiteAdminCode } from '../apiHelpers'

export const getPermissions = async (params) => {
  const { data } = await clasolSuiteApi.get('/permissions', {
    params: buildListParams(params),
    ...withSuiteAdminCode(),
  })
  return data
}

export const getPermission = async (id) => {
  const { data } = await clasolSuiteApi.get(`/permissions/${encodeURIComponent(id)}`, withSuiteAdminCode())
  return data
}

export const createPermission = async (permission) => {
  const { data } = await clasolSuiteApi.post('/permissions', permission, withSuiteAdminCode())
  return data
}

export const updatePermission = async (id, permission) => {
  const { data } = await clasolSuiteApi.patch(`/permissions/${encodeURIComponent(id)}`, permission, withSuiteAdminCode())
  return data
}

export const deletePermission = async (id) => {
  await clasolSuiteApi.delete(`/permissions/${encodeURIComponent(id)}`, withSuiteAdminCode())
}
